import React, { PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { useResponsive } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const SweetpassInfoContainer = (props: PropsWithChildren) => {
  const { children } = props;
  const { match } = useResponsive();

  return (
    <View style={match([styles.containerXS, styles.containerSM, styles.containerMD])}>
      {children}
    </View>
  );
};

const Divider = () => {
  const { match } = useResponsive();

  return <View style={match([styles.dividerXS, styles.dividerSM])} />;
};

SweetpassInfoContainer.Divider = Divider;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    gap: theme.spacing['6'],
  },
  containerSM: {
    gap: theme.spacing['10'],
    paddingTop: theme.spacing['10'],
    paddingHorizontal: theme.spacing['4'],
    paddingBottom: theme.spacing['4'],
    borderRadius: theme.radius.large,
    borderWidth: 1,
    borderColor: theme.colors.GRAY,
  },
  containerMD: {
    gap: theme.spacing['10'],
    paddingTop: theme.spacing['10'],
    paddingHorizontal: theme.spacing['6'],
    paddingBottom: theme.spacing['4'],
    borderRadius: theme.radius.large,
    borderWidth: 1,
    borderColor: theme.colors.GRAY,
  },
  dividerXS: {
    marginHorizontal: -theme.spacing['4'],
    height: 8,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderTopColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
    borderBottomColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
  },
  dividerSM: {
    marginHorizontal: -theme.spacing['6'],
    height: 8,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderTopColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
    borderBottomColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
  },
});
